import api from './api';
import { Campaign, CreateCampaignRequest, Prize } from '../types';

// Função utilitária para normalizar dados de prêmio
const normalizePrize = (prize: any): Prize => {
  if (!prize) return {} as Prize;
  
  return {
    id: prize.id || '',
    name: prize.name || '',
    quantity: prize.quantity || 0,
    createdAt: prize.createdAt || new Date().toISOString(),
  };
};

// Função utilitária para normalizar campanha
const normalizeCampaign = (campaign: any): Campaign => ({
  ...campaign,
  prizes: campaign.prizes ? campaign.prizes.map(normalizePrize) : []
});

// Função utilitária para normalizar array de campanhas
const normalizeCampaigns = (campaigns: any[]): Campaign[] => 
  campaigns.map(normalizeCampaign);

export const campaignService = {
  async getAllCampaigns(): Promise<Campaign[]> {
    const response = await api.get('/campaigns');
    return normalizeCampaigns(response.data);
  },

  async getCampaignsByAssociation(): Promise<Campaign[]> {
    // Este endpoint já filtra por associação no backend
    const response = await api.get('/campaigns');
    return normalizeCampaigns(response.data);
  },

  async getCampaignById(id: string): Promise<Campaign> {
    const response = await api.get(`/campaigns/${id}`);
    // Buscar prêmios específicos desta campanha se necessário
    try {
      const prizesResponse = await api.get(`/prizes/campaign/${id}`);
      const normalizedCampaign = normalizeCampaign(response.data);
      return {
        ...normalizedCampaign,
        prizes: prizesResponse.data.map(normalizePrize)
      };
    } catch (error) {
      console.error('Erro ao buscar prêmios da campanha:', error);
      return normalizeCampaign(response.data);
    }
  },

  async createCampaign(campaign: CreateCampaignRequest): Promise<Campaign> {
    const response = await api.post('/campaigns', campaign);
    return normalizeCampaign(response.data);
  },

  async updateCampaign(id: string, campaign: Partial<CreateCampaignRequest>): Promise<Campaign> {
    console.log('🔄 CampaignService.updateCampaign chamado:', { id, campaign });
    const response = await api.put(`/campaigns/${id}`, campaign);
    console.log('✅ CampaignService.updateCampaign resposta:', response.data);
    return normalizeCampaign(response.data);
  },

  async deleteCampaign(id: string): Promise<void> {
    await api.delete(`/campaigns/${id}`);
  },

  async getActiveCampaigns(): Promise<Campaign[]> {
    console.log('📡 CampaignService: Buscando campanhas ativas...');
    
    try {
      const response = await api.get('/campaigns/active');
      console.log('✅ CampaignService: Campanhas recebidas do backend:', response.data.length);
      
      const normalizedCampaigns = normalizeCampaigns(response.data);
      console.log('🔄 CampaignService: Campanhas normalizadas:', normalizedCampaigns.length);
      
      return normalizedCampaigns;
    } catch (error) {
      console.error('❌ CampaignService: Erro ao buscar campanhas do backend:', error);
      throw error;
    }
  }
}; 